import api, { setAuthToken } from "./api";

interface LoginData {
  username: string;
  password: string;
}

export const login = async (username: string, password: string) => {
  const response = await api.post("/auth/login", { username, password });
  const { token, id, roleNames } = response.data;

  // Save token in memory
  setAuthToken(token);

  // Save token and user in localStorage
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify({ username, id, roleNames }));

  return response.data;
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};
